<!-- 二代网关数据处理封装 -->
<template>
  <el-form ref="form" :model="dioForm" label-position="right" label-width="150px" label-suffix="：">
    <el-form-item :label="$t('integration.auto_configuration')" prop="autoGenNetParam">
      <el-select
        v-model="dioForm.autoGenNetParam"
        v-if="!isClickConfig"
        style="width: 250px"
      >
        <el-option :value="1" label="True"></el-option>
        <el-option :value="0" label="False"></el-option>
      </el-select>
      <template v-else>
        <Modify :item="dioForm['autoGenNetParamCurrent']"></Modify>
      </template>
    </el-form-item>
    <template v-if="!dioForm.autoGenNetParam">
      <el-form-item
        label="LpwanMode"
        prop="lpwanMode"
        :rules="[RuleRequiredFunc($t('integration.please_select_lpwan_mode'))]"
      >
        <el-select
          v-model="dioForm.lpwanMode"
          v-if="!isClickConfig"
          style="width: 250px"
        >
          <el-option
            :value="item"
            :key="key"
            :label="key"
            v-for="(item, key) in ENUM_GATEWAY_LPWAN_MODE"
          ></el-option>
        </el-select>

        <template v-else>
          <Modify :item="dioForm['lpwanModeCurrent']"></Modify>
        </template>
      </el-form-item>
      <el-form-item :label="$t('Pan ID')" prop="panId" :rules="RulePanId">
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.panId"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else>
          <Modify :item="dioForm['panIdCurrent']"></Modify>
        </template>
      </el-form-item>

      <el-form-item
        :label="$t('Ext Pan ID')"
        prop="extPanId"
        :rules="RuleExtPanId"
      >
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.extPanId"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else>
          <Modify :item="dioForm['extPanIdCurrent']"></Modify>
        </template>
      </el-form-item>
    </template>
  </el-form>
</template>

<script>
import Modify from '@/pages/equipment/base/components/configInfo/Modify.vue'
import { RuleExtPanId, RulePanId, RuleRequiredFunc } from '@/utils/rules'
import { ENUM_GATEWAY_LPWAN_MODE } from '@/common/enum/forward/device'

export default {
  props: {
    // view | edit
    mode: {
      type: String
    },
    JsonContent: {
      type: Object
    }
  },

  components: { Modify },
  watch: {
    JsonContent: {
      handler () {
        if (!this.JsonContent || !this.JsonContent.item) return
        const JsonContent = this.JsonContent
        const rawLpwanMode = JsonContent.item.lpwan_mode && JsonContent.item.lpwan_mode.modify
        // modify 可能是数字（1/2/3）或字符串（"MODEM_GF" 等），统一转换为数字以匹配 el-option 的 value
        const lpwanModeVal = rawLpwanMode
          ? (typeof rawLpwanMode === 'number' ? rawLpwanMode : ENUM_GATEWAY_LPWAN_MODE[rawLpwanMode])
          : rawLpwanMode
        this.dioForm = {
          autoGenNetParam: JSON.parse(
            JsonContent.item.auto_gen_net_param.modify
          )
            ? 1
            : 0,
          autoGenNetParamCurrent: JsonContent.item.auto_gen_net_param,
          lpwanMode: lpwanModeVal,
          lpwanModeCurrent: JsonContent.item.lpwan_mode,
          panId: JsonContent.item.pan_id && JsonContent.item.pan_id.modify,
          panIdCurrent: JsonContent.item.pan_id,
          extPanId:
            JsonContent.item.ext_pan_id && JsonContent.item.ext_pan_id.modify,
          extPanIdCurrent: JsonContent.item.ext_pan_id
        }
      },
      immediate: true,
      deep: true
    },
    mode: {
      handler () {
        if (this.mode === 'view') {
          this.$refs.form.clearValidate()
        } else if (
          this.mode === 'edit' &&
          !Object.keys(this.JsonContent).length
        ) {
          // JSON CONTENT不存在 设置Dioform的默认值
          this.dioForm = {
            extPanId: '50414e4944303032',
            autoGenNetParam: 1,
            lpwanMode: 3,
            panId: '1234'
          }
        }
      }
    }
  },
  data () {
    return {
      dioForm: {}
    }
  },
  methods: {
    // 暴露给父级调用  返回服务器接受的参数
    async getData () {
      await this.$refs.form.validate()
      const { extPanId, autoGenNetParam, lpwanMode, panId } = this.dioForm
      return {
        auto_gen_net_param: autoGenNetParam,
        ext_pan_id: extPanId,
        pan_id: panId,
        lpwan_mode: lpwanMode
      }
    }
  },
  computed: {
    ENUM_GATEWAY_LPWAN_MODE () {
      return ENUM_GATEWAY_LPWAN_MODE
    },
    RulePanId: () => RulePanId,
    isClickConfig () {
      return this.mode === 'view'
    },
    RuleRequiredFunc: () => RuleRequiredFunc,
    RuleExtPanId: () => RuleExtPanId
  }
}
</script>
